/* tslint:disable:component-selector */
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {NinjaData} from '../../../models/ninja-data.model';

@Component({
  selector: 'map-country-dialog',
  templateUrl: './map-country-dialog.component.html',
  styleUrls: ['./map-country-dialog.component.scss']
})
export class MapCountryDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

  country: NinjaData;

  ngOnInit(): void {
    this.country = this.data.countryData;
  }

}
